import he from 'he';
import striptags from 'striptags';

const HTML_ALLOWED_TAGS = ['a', 'b', 'br', 'em', 'i', 'p', 'small', 'strong'];

const KIOSK_ALLOWED_TAGS = [
	// no open links in kiosk mode!
	'b',
	'br',
	'em',
	'i',
	'p',
	'small',
	'strong',
];

export const sanitize = (html: string, allowedTagsOverride?: string[]) =>
	striptags(html, ...[allowedTagsOverride || HTML_ALLOWED_TAGS]);

export const kioskSanitize = (html: string) =>
	sanitize(html, KIOSK_ALLOWED_TAGS);

export const htmlToPlainText = (html?: string | null) => {
	if (!html) return undefined;

	// "<p>Arms &amp; Armor</p><p>collection</p>" becomes
	// "Arms & Armor collection", not "Arms &amp; Armorcollection".
	const plainText = he
		.decode(striptags(html, [], ' '))
		.replace(/\s+/g, ' ')
		.trim();

	return plainText || undefined;
};

export const truncateText = (
	text?: string | null,
	maxLength?: number,
	appendEllipsis = false,
) => {
	if (!text) return undefined;

	const plainText = text.trim();
	if (!plainText) return undefined;
	if (maxLength === undefined) return plainText;
	if (plainText.length <= maxLength) return plainText;

	const ellipsis = appendEllipsis && maxLength > 3 ? '...' : '';
	const truncateAt = Math.max(maxLength - ellipsis.length, 0);
	const truncated = plainText.slice(0, truncateAt + 1);
	const lastSpace = truncated.lastIndexOf(' ');

	const truncatedText = truncated
		.slice(0, lastSpace > 0 ? lastSpace : truncateAt)
		.trim();

	return `${truncatedText}${ellipsis}`;
};
